import React from 'react';
export function SmartSegmentationHeader() {
  return <header className="fixed top-0 z-50 w-full bg-white shadow-sm py-3" data-id="element-695">
            <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-696">
                <div className="flex justify-between items-center" data-id="element-697">
                    <div className="flex items-center" data-id="element-698">
                        <a href="/" className="flex-shrink-0" data-id="element-699">
                            <img src="https://mirrorful-production.s3.us-west-1.amazonaws.com/patterns/assets/xckowmcscdatvwqg3ex8v2/3eb2f218-c9ff-4fe6-ad82-ebadfcc155d3/Nf_final.png" alt="Newsfiliate Logo" className="h-8" data-id="element-700" />
                        </a>
                    </div>

                    {/* Empty space for navigation - intentionally left blank */}
                    <div className="flex-1" data-id="element-701"></div>

                    <div className="flex items-center" data-id="element-702">
                        <a href="#join-beta" className="px-5 py-2.5 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition-all hover:shadow-md" data-id="element-703">
                            Join Beta
                        </a>
                    </div>
                </div>
            </div>
        </header>;
}